export enum ProductType {
    Unknown = 'Unknown',
    Product = 'Product',
    Service = 'Service',
    Part = 'Part',
}
